import * as React from 'react';
import type { MetadataResponse } from '~/services/api.server';

export function useMetadata() {
  const [data, setData] = React.useState<MetadataResponse['results']>();

  React.useEffect(() => {
    fetch('/api/metadata')
      .then((res) => res.json())
      .then(setData);
  }, []);

  return data;
}
